import React, { useEffect } from 'react';
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
} from 'react-google-maps';
import { gsap } from 'gsap';

//Components
import useObserver from './useObserver';

const GMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={16}
      defaultCenter={{ lat: 42.742179, lng: 23.236083 }}
    >
      <Marker
        position={{
          lat: 42.742179,
          lng: 23.236083,
        }}
      />
    </GoogleMap>
  ))
);

const Map = props => {
  const [ref, setRef, animate] = useObserver({
    init: true,
    root: null,
    rootMargin: `-20% 0% -20% 0%`,
  });

  useEffect(() => {
    if (ref && window.innerWidth > 767) {
      gsap.set(ref, {
        opacity: 0,
        yPercent: 20,
        force3D: true,
      });

      gsap.set(ref.querySelector('.map__container'), {
        xPercent: 100,
        opacity: 0.2,
        force3D: true,
      });
    }
  }, [ref]);

  useEffect(() => {
    if (animate && window.innerWidth > 767) {
      gsap.to(ref, {
        duration: 0.6,
        delay: 0.4,
        opacity: 1,
        yPercent: 0,
        force3D: true,
      });

      gsap.set(ref.querySelector('.map__container'), {
        duration: 0.7,
        delay: 1,
        xPercent: 0,
        opacity: 1,
        force3D: true,
      });
    }
  }, [animate, ref]);

  return (
    <div
      ref={setRef}
      className="map d-flex ml-auto pb-7 pb-md-12 pb-lg-18 pb-xl-25 pb-mg-32"
    >
      <div className="map__decoration d-flex align-items-center justify-content-center">
        <i
          className="fal fa-map-marker-alt text-white"
          style={{ fontSize: 32 }}
        ></i>
      </div>

      <GMap
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.GATSBY_GOOGLE_MAP_API_KEY}`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div className="map__container" />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </div>
  );
};

export default Map;
